import(/* webpackMode: "eager" */ "/workspace/app/views/academics/components/AcademicCards.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/authors/components/AuthorCarousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/Hero/components/Hero.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/popular/components/PopularCarousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/components/ui/separator.jsx");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js")